var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoreHorizontal = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 12a3 3 0 1 1 5.999-.001A3 3 0 0 1 1 12Zm4.266.007c0-.697-.57-1.266-1.266-1.266-.696 0-1.266.57-1.266 1.266 0 .696.57 1.265 1.266 1.265.696 0 1.266-.569 1.266-1.265ZM11.54 9a3 3 0 1 0-.001 5.999A3 3 0 0 0 11.54 9Zm0 1.741c.697 0 1.266.57 1.266 1.266 0 .696-.57 1.265-1.266 1.265-.696 0-1.265-.569-1.265-1.265 0-.697.569-1.266 1.265-1.266ZM19.154 9a3 3 0 1 0-.001 5.999 3 3 0 0 0 0-5.999Zm0 1.741c.696 0 1.265.57 1.265 1.266 0 .696-.569 1.265-1.265 1.265-.697 0-1.266-.569-1.266-1.265 0-.697.57-1.266 1.266-1.266Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoreHorizontal);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MoreHorizontal.fc5abc4ea2b25848f78afd11c5cab10c.svg";